// Common response interfaces
export interface BaseResponse {
  id: number;
  created_at: string;
  updated_at?: string;
  created_by: number;
  updated_by?: number;
}

export interface CreateResponseData {
  id: number;
  message?: string;
}

export interface UpdateResponseData {
  message?: string;
  success?: boolean;
}

export interface PagedResults<T> {
  items: T[];
  statistics?: T[];
  total_items: number;
  total_pages: number;
  current_page: number;
}

// Enums
export enum CommissionFrequency {
  Weekly = 'Weekly',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly'
}

export enum CommissionRuleCategory {
  AppointmentUsageBased = 'appointment_usage_based',
  SalesBased = 'sales_based',
  ClassUsageBased = 'class_usage_based'
}

export enum CommissionSalesBasis {
  OnSale = 'on_sale',
  OnRevenue = 'on_revenue',
  OnPayment = 'on_payment',
  SessionCount = 'session_count'
}

export enum CommissionScopeType {
  All = 'all',
  SubscriptionPlan = 'subscription_plan',
  ServiceCategory = 'service_category',
  RetailItem = 'retail_item',
  Campaign = 'campaign'
}

export enum CommissionRateType {
  Percentage = 'percentage',
  FlatFee = 'flat_fee'
}

export enum OwnershipLevel {
  Company = 'company',
  FranchiseGroup = 'franchise_group',
  Tenant = 'tenant'
}

